import { render } from "./DispDate.vue?vue&type=template&id=26ace696"
import script from "./DispDate.vue?vue&type=script&lang=js"
export * from "./DispDate.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Custom/DispDate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "26ace696"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('26ace696', __exports__)) {
    console.log('reload')
    api.reload('26ace696', __exports__)
  }
  
  module.hot.accept("./DispDate.vue?vue&type=template&id=26ace696", () => {
    console.log('re-render')
    api.rerender('26ace696', render)
  })

}


export default __exports__